import React from 'react';

import { SpaceBase } from '@confluence/space-base/entry-points/SpaceBase.ts';

export default (props) => {
	return <SpaceBase {...props} />;
};
